// Define the base KanbanCandidate type directly without importing
export interface KanbanCandidate {
	id: string;
	name: string;
	skills: string[];
	score?: number;
	stage: string;
	candidateId: string;
	jobId: string;
	companyId?: string;
	email?: string;
	jobTitle?: string;
	createdAt?: string;
	company?: string;
	position?: string;
	date?: string;
	analysisInProgress?: boolean;
	applicationsCount?: number;
	processesCount?: number;
	published?: boolean; // For job cards in kanban view
}

export interface KanbanStage {
	id: string;
	name: string;
}

export const ACTIVE_KANBAN_STAGE_IDS = [
	'applied',
	'matched',
	'screening',
	'sent',
	'interview',
	'offer',
	'hired'
] as const;

export const REFUSED_MATCH_STATUSES = [
	'application_closed',
	'candidate_not_available',
	'candidate_not_interested',
	'offer_rejected_by_candidate',
	'rejected_by_customer',
	'rejected_by_recruter'
] as const;

export const getKanbanStageId = (status?: string | null, knownStageIds?: string[]): string => {
	if (!status)
		return 'matched';

	if (knownStageIds
		? knownStageIds.includes(status)
		: ACTIVE_KANBAN_STAGE_IDS.includes(status as typeof ACTIVE_KANBAN_STAGE_IDS[number]))
		return status;

	return 'refused';
};

// Define all recruitment stages in order
export const KANBAN_STAGES: KanbanStage[] = [
	{ id: 'applied', name: 'Applied' },
	{ id: 'matched', name: 'Matched' },
	{ id: 'screening', name: 'Screening' },
	{ id: 'sent', name: 'Sent' },
	{ id: 'interview', name: 'Interview' },
	{ id: 'offer', name: 'Offer' },
	{ id: 'hired', name: 'Hired' },
	{ id: 'refused', name: 'Refused' }
];
